module.exports = __webpack_public_path__ + "media/3.b52572e0.mp3";